import { render, staticRenderFns } from "./TermsService.vue?vue&type=template&id=c40f796a&scoped=true"
import script from "./TermsService.vue?vue&type=script&lang=js"
export * from "./TermsService.vue?vue&type=script&lang=js"
import style0 from "./TermsService.vue?vue&type=style&index=0&id=c40f796a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40f796a",
  null
  
)

export default component.exports